module.exports = __webpack_public_path__ + "img/box1.576f968d.svg";